import React from 'react'
import classnames from 'classnames'

import styles from './index.scss'

export default class ButtonStandard extends React.Component {
  render () {
    const {
      style,
      containerClassname,
      className,
      onClick,
      children,
      primary,
      secondary,
      tertiary,
      title,
      other
    } = this.props

    return (
      <div className={classnames('d-inline-block', containerClassname)}>
        <button type='button' onClick={onClick} title={title} className={classnames(styles.defaultButtonStyling, primary ? styles.primary : '', secondary ? styles.secondary : '', tertiary ? styles.tertiary : '', other ? styles.other : '', className)} style={style}>{children}</button>
      </div>
    )
  }
}
